import { render } from "./Compile.vue?vue&type=template&id=17222128&scoped=true"
import script from "./Compile.vue?vue&type=script&lang=js"
export * from "./Compile.vue?vue&type=script&lang=js"

import "./Compile.vue?vue&type=style&index=0&id=17222128&scoped=true&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17222128"]])

export default __exports__